// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-not-found[data-v-6b3e73bf]{height:100%}`, "",{"version":3,"sources":["webpack://./src/components/CollectiveNotFound.vue"],"names":[],"mappings":"AACA,oCACC,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
